// App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { RechtenProvider } from "./context/RechtenContext";
import WelkomPagina from "./components/WelkomPagina";
import AppRoutes from "./AppRoutes";
import config from "./config";

export default function App() {
  const { instance } = useMsal();
  const [klantStatus, setKlantStatus] = useState("loading");

  useEffect(() => {
    const token = sessionStorage.getItem("access_token");
    if (!token) {
      setKlantStatus("idle"); // nog niet ingelogd
      return;
    }

    // ✅ klantstatus check
    fetch(`${config.API_URL}/klantstatus`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("🔎 Klantstatus API response:", data);
        if (!data.isCustomer) setKlantStatus("notCustomer");
        else if (data.code === "STAGING_ACCESS_DENIED") setKlantStatus("stagingDenied");
        else if (!data.portalActive) setKlantStatus("notActivated");
        else setKlantStatus("ok");
      })
      .catch(() => setKlantStatus("error"));
  }, []);

  return (
    <Router>
      {klantStatus === "loading" && (
        <div className="p-6 text-center text-gray-500">
          🔍 Klantstatus wordt gecontroleerd...
        </div>
      )}

      {klantStatus === "ok" ? (
        <RechtenProvider>
          <AppRoutes /> {/* ✅ geen klantStatus meer doorgeven */}
        </RechtenProvider>
      ) : (
        <WelkomPagina status={klantStatus} />
      )}
    </Router>
  );
}
